import { defaultUnderlying } from "#/config/markets";
import { useIndexPrices } from "#/store/app/indexPrices/indexPrices";
import { PortfolioSymbol } from "#/types/markets";
import { nextMaturities } from "#/utils/maturities";
import { roundToNearest } from "#/utils/number.utils";

const ROUND_FACTOR = 1000;
const DEFAULT_INDEX_PRICE =
  defaultUnderlying === PortfolioSymbol.BTC ? 100000 : 2000;

export const useZeroTradingFeesSlideController = () => {
  const [closestExpiry] = nextMaturities();
  const { indexPrices } = useIndexPrices();
  const indexPrice = indexPrices[defaultUnderlying];
  const roundedIndexPrice = roundToNearest(
    indexPrice || DEFAULT_INDEX_PRICE,
    ROUND_FACTOR,
  );

  return {
    instrumentName: `${defaultUnderlying}-${closestExpiry}-${roundedIndexPrice}-C`,
  };
};
